import { Dialog, DialogAction } from "../core/components/dialog.js";
import { FAIcon } from "../core/components/faIcon.js";
import { ToggleButtonGroup } from "../core/components/toggleButtonGroup.js";
import { Button } from "../core/components/button.js";
import { SimpleCheckBox } from "../core/components/simpleCheckBox.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { SchedulerClasses } from "./scheduler.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { General } from "../../siteManagement/general.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import TimeSpanManager from "../core/components/timeSpanManager.js";
import end = kendo.data.binders.widget.end;
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";

export class TimeSpanFilter extends React.Component<ResourcePlanningSchedulerTimeSpanManagerProps, TimeSpanManagerState> {
    private diffDays: number = 0;
    private prevCustomDiff = 0;
    private nextCustomDiff = 0;
    private factory = ComponentHelper.createFactory();
    private dialogRef: Dialog = null;
    private assignmentArea: JQuery = null;
    private columnSizes = {
        //constant
        bestFitWidth: 35,
        //constant
        minWidth: 35,
        ////number of columns using min width
        //minCount: 0,
        ////number of columns using min width
        //bestFitCount: 0,
        //width of container
        containerWidth: 0
    };
    // @ts-ignore
    private lastTimeSpanStorageId = `LastTimeSpan_${Config.user.userName}`;

    private _toggleGroupStyle: React.CSSProperties = {
        margin: "0 10px 10px 0",
        display: "flex"
    };
    private prevCells: number = 3;
    private dialogActions: Array<DialogAction> = [
        {
            label: Config.translations.cancel,
            action: () => {
                this.setState({ selectedTimeSpan: null })
                this.dialogButtonClicked = true;
                this.closeDialog(true);
            }
        },
        {
            label: Config.translations.apply,
            action: () => {
                if (!this.isDateRangeValid()) {
                    NotificationHelper.showErrorMessage(this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.InvalidTimeSpan"]);
                    return false;
                }
                this.dialogButtonClicked = true;
                const dps = (window["dps"] as DayPilot.Scheduler);
                Helper.saveDataToStorage("timeSpanManager_fitToScreen", this.state.fitToScreen, false);
                if (this.state.fitToScreen) {
                    let isValid =
                        //no recommendation
                        !this.state.recommendation
                        //no change to the time span filter controlls (start date, end date, zoom level)
                        || (
                            !Helper.hasValue(this.state.recommendation.endDate)
                            && !Helper.hasValue(this.state.recommendation.minFit)
                        )
                        || (
                            //the current zoom level is higher than or equal to the recommended level
                            this.state.resolution >= this.state.recommendation.minFit &&
                            //the current end date is smaller than or equal to the recommended date
                            Helper.dates.compareMultiTypeDates(this.state.end, this.state.recommendation.endDate, true) < 1
                        );

                    if (isValid) {
                        if (this.hasDataChanged()) {
                            const setSchedulerToAuto = (data: any) => {
                                if (data && data.type === "schedulerDataLoaded") {
                                    dps.cellWidthSpec = "Auto";
                                    dps.update();
                                    this.sheet.unbind(SheetEventType.Custom, setSchedulerToAuto);
                                }
                            }

                            if (!this.fitToScreenOnOpen) {
                                this.sheet.bind(SheetEventType.Custom, setSchedulerToAuto);
                            }

                            this.sendValues(this.state.start, this.state.end, this.state.resolution);
                        } else {
                            dps.cellWidthSpec = "Auto";
                            dps.update();
                        }
                        this.closeDialog(false);
                    } else {
                        DialogHelper.alert(this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.TimeSpanTooLong"]);
                        return false;
                    }
                } else {
                    if (this.fitToScreenOnOpen) {
                        dps.cellWidthSpec = "Fixed";
                        dps.cellWidth = this.props.fixedCellWidth;
                        dps.update();
                    }
                    this.sendValues(this.state.start, this.state.end, this.state.resolution, false, true);
                    this.closeDialog(false);
                }

                Helper.saveDataToStorage(this.lastTimeSpanStorageId, { start: this.state.start, end: this.state.end, resolution: this.state.resolution }, false)



            },
            primary: true
        }
    ];
    private resolutionDataSource: Array<ZoomDataItem> = null;
    // @ts-ignore
    private _commandLinkStyle: React.CSSProperties = {
        color: "black",
        fontSize: "12px",
        marginTop: "10px"
    };
    private fitToScreenOnOpen: boolean = true;
    private sheet: Sheet = null;
    // @ts-ignore
    private _timeSpanStyle: React.CSSProperties = {
        cursor: "pointer",
        padding: "5px 10px",
        border: "1px solid #b3b3b3",
        borderRight: "none",
        height: "38px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0px 0 10px 10px",
        flexShrink: 0,
        borderRadius: "var(--rounded-left)"
    };
    private dialogButtonClicked = false;
    private timeFrameTemplates: TimeSpanTemplate[] = [];
    //private _pbUnits: {
    //    unitMonths: number,
    //    unitWeeks: number,
    //    unitDays: number
    //} = {
    //        unitDays: 30,
    //        unitMonths: 10,
    //        unitWeeks: 20
    //    };

    private timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }


    constructor(props: ResourcePlanningSchedulerTimeSpanManagerProps) {
        super(props);
        let fitToScreen = props.fitToScreen;
        if (!Helper.hasValue(fitToScreen)) {
            fitToScreen = Helper.loadDataFromStorage("timeSpanManager_fitToScreen");
            if (!Helper.hasValue(fitToScreen)) {
                fitToScreen = true;
            }
        }
        this.state = {
            start: props.start,
            end: props.end,
            resolution: props.timeResolutionType,
            fitToScreen: fitToScreen,
            showDialog: false,
            recommendation: null,
            selectedTimeSpan: null
        };
        const diff = this.getDiffs();
        this.prevCustomDiff = diff.customPrev;
        this.nextCustomDiff = diff.customNext;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.setKeyUps()
    }

    private setKeyUps = () => {
        $(document).on("keydown", this.onKeyDown);
    }

    private onKeyDown = (e: any) => {
        const arrowLeft = 37;
        const arrowRight = 39;
        let ctrl: boolean = e.ctrlKey;
        let keyCode: number = e.keyCode;
        if (General.Sheet.Manager.getTopMostSheet().id() === this.sheet.id() && !Helper.isDialogOpen() && !this.props.disabled && document.activeElement.nodeName.toLowerCase() === "body") {
            if (ctrl) {
                switch (keyCode) {
                    case arrowLeft:
                        this.navigatePrev();
                        break;
                    case arrowRight:
                        this.navigateNext();
                        break;
                }
            } else {
                switch (keyCode) {
                    case arrowLeft:
                        this.navigatePrevCustom();
                        e.preventDefault();
                        e.stopPropagation();
                        break;
                    case arrowRight:
                        this.navigateNextCustom();
                        e.preventDefault();
                        e.stopPropagation();
                        break;
                }
            }
        }
    }

    update = (fitScreenSize: boolean, zoom: number) => {
        this.setState({ fitToScreen: fitScreenSize, resolution: zoom }, () => {
            this.onFilterPartChange("fitToScreen", fitScreenSize, true);
            this.onFilterPartChange("resolution", zoom, true);
        })
    }

    private setDialogRef = (r: Dialog) => {
        this.dialogRef = r;
    }

    private isDateRangeValid = (start: SD = this.state.start, end: SD = this.state.end) => {
        return Helper.dates.compareMultiTypeDates(start, end, true) !== 1
    }

    private getResolutionDropDownProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.field.optionLabel = "";
        if (Array.isArray(this.resolutionDataSource)) {
            props.dataSource = this.resolutionDataSource;
        } else {
            props.field.dataSourceUrl = "ResourcePlanningLookup/GetSchedulerTimeResolutions";
        }
        props.field.dataTextField = "Description";
        props.field.dataValueField = "TimeResolution";
        props.value = this.state.resolution;
        props.onDataLoaded = (_, data: Array<ZoomDataItem>) => {
            this.resolutionDataSource = data;
        }
        props.onChange = (_, value) => {
            this.onFilterPartChange("resolution", value, false);
        }
        return props;
    }

    private refreshDimensionsAndColumnCounts = (force: boolean) => {
        if ((Helper.hasValue(this.dialogRef) && this.dialogRef.isOpen()) || force) {
            this.assignmentArea = $("." + SchedulerClasses.Scrollable);
            this.columnSizes.containerWidth = this.assignmentArea.width();
        }
    }

    public openDialog = (startDate: Date = null, endDate: Date = null) => {
        if (!this.props.disabled) {
            this.fitToScreenOnOpen = this.state.fitToScreen;
            this.setState({
                showDialog: true,
                start: startDate != null ? startDate : this.props.start,
                end: endDate != null ? endDate : this.props.end,
                resolution: this.props.timeResolutionType,
                recommendation: null
            }, () => {
                //always get dimensions
                this.refreshDimensionsAndColumnCounts(true);

                if (this.state.fitToScreen) {
                    const fitCount = this.getColumnCounts(this.props.timeResolutionType);
                    this.checkTimeRange(this.props.start, this.props.end, this.props.timeResolutionType, fitCount.minCount, fitCount.bestFitCount, RerenderCondition.BestFit, false);
                }
            });
        }
    }

    private closeDialog = (isReset: boolean) => {
        this.setState({
            showDialog: false,
            start: null,
            end: null,
            recommendation: null,
            fitToScreen: isReset ? this.fitToScreenOnOpen : this.state.fitToScreen
        });
    }

    private onFilterPartChange = <U extends keyof TimeSpanManagerState>(model: U, value: TimeSpanManagerState[U], noCheck: boolean) => {
        // Unzulässiges Datum auf aktuellen Tag ändern
        if ((model === "start" || model == "end") && !Helper.hasValue(value))
            value = Helper.dates.getISODateString(new Date()) as any;

        //... ... ... :| ... ... ...
        let state: Pick<TimeSpanManagerState, U> = {
            [model]: value
        } as any;

        this.diffDays = (model === 'start') ? Helper.dates.dateDiffInDays(this.state.start, this.state.end) : 0;

        this.setState(state, noCheck ? null : () => {
            if (this.state.fitToScreen) {
                const fitCount = this.getColumnCounts(this.state.resolution);
                this.checkTimeRange(this.state.start, this.state.end, this.state.resolution, fitCount.minCount, fitCount.bestFitCount, RerenderCondition.MinFit, false);
            }
            if (this.diffDays > 0 && this.state.start !== null) {
                const newend = Helper.dates.getISODateString(Helper.dates.addDays(Helper.dates.toDate(this.state.start), this.diffDays));
                this.setState({ end: newend });
            }
        });
    }

    private sendValues = (start: SD, end: SD, resolution: number, doNotChangeCellWidth: boolean = false, setSchedulertoStartDate: boolean = false) => {
        this.props.onTimeSpanChanged(start, end, resolution, doNotChangeCellWidth, setSchedulertoStartDate);
    }

    private getColumnCounts = (resolution: number) => {
        const result: ColumnFitSizes = {
            //number of columns using min width
            minCount: Math.floor(this.columnSizes.containerWidth / this.columnSizes.minWidth),
            //number of columns using min width
            bestFitCount: Math.floor(this.columnSizes.containerWidth / this.columnSizes.bestFitWidth)
        };

        if (resolution === 0) {
            const remainder = result.minCount % 24;
            const quotient = Math.floor(result.minCount / 24);
            if (remainder >= 12) {
                result.minCount = (quotient + 1) * 24;
            } else {
                result.minCount = quotient * 24;
            }
        }

        return result;
    }

    private getTimeFrameChecks = (start: SD, end: SD, resolution: number, maxUnits: number, bestFitUnits: number) => {
        const data: StringKeyDictionary<any> = {
            start: Helper.dates.getISODateString(start),
            end: Helper.dates.getISODateString(end),
            timeResolution: resolution
        };
        if (Helper.hasValue(maxUnits)) {
            data.maxUnits = maxUnits;
        }
        if (Helper.hasValue(maxUnits)) {
            data.bestFitUnits = bestFitUnits;
        }

        return HTTPService.get<JsonResultClass<Recommendation>>("ResourcePlanningScheduler/CheckTimeFrame", data);
    }

    private checkTimeRange = async (start: SD, end: SD, resolution: number, maxUnits: number, bestFitUnits: number, renderCondition: RerenderCondition, sendValuesIfValid: boolean) => {
        if (this.isDateRangeValid(start, end)) {
            let result;
            try {
                result = await this.getTimeFrameChecks(start, end, resolution, maxUnits, bestFitUnits);
            } catch {
                NotificationHelper.showErrorMessage(Config.translations.noConnection);
                return;
            }
            if (result.Code === 0) {
                let shouldUpdate = false;

                switch (renderCondition) {
                    case RerenderCondition.Always:
                        shouldUpdate = true;
                        break;
                    case RerenderCondition.MinFit:
                        shouldUpdate = true;
                        break;
                    case RerenderCondition.BestFit:
                        if (result.Data.bestFit !== this.state.resolution && (this.state.recommendation === null || this.state.recommendation.bestFit !== result.Data.bestFit)) {
                            shouldUpdate = true;
                            result.Data.endDate = null;
                            result.Data.minFit = null;
                            result.Data.units = null;
                        }
                        break;
                    case RerenderCondition.Never:
                    default:
                        break;
                }

                const sendValues = () => {
                    if (sendValuesIfValid && this.state.recommendation && this.state.recommendation.minFit === result.Data.minFit) {
                        this.closeDialog(false);
                        this.props.onTimeSpanChanged(start, end, resolution);
                    }
                }

                if (shouldUpdate) {
                    this.setState({ recommendation: result.Data }, sendValues);
                } else {
                    sendValues();
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private navigateNext = () => {
        this.props.onTimeSpanChanged(this.props.nextStart, this.props.nextEnd, this.props.timeResolutionType, true);
    }

    private navigatePrev = () => {
        this.props.onTimeSpanChanged(this.props.prevStart, this.props.prevEnd, this.props.timeResolutionType, true);
    }

    private navigateNextCustom = () => {
        this.props.onTimeSpanChanged(this.props.nextCustomStart, this.props.nextCustomEnd, this.props.timeResolutionType, true);
    }

    private navigatePrevCustom = () => {
        this.props.onTimeSpanChanged(this.props.prevCustomStart, this.props.prevCustomEnd, this.props.timeResolutionType, true);
    }

    private navigateToday = () => {
        let now = Helper.dates.toDate(new Date());
        // Wenn der heutige Tag im datrgestellten Zeitraum liegt wird zu diesem Tag hingescrollt ohne neue Daten vom Server zu holen

        if (Helper.dates.compareMultiTypeDates(now, this.props.start, true) != -1 && Helper.dates.compareMultiTypeDates(this.props.end, now, true) != -1) {
            const dps = (window["dps"] as DayPilot.Scheduler);

            const today = Helper.dates.getISODateString(new Date(now.getFullYear(), now.getMonth(), now.getDate()));

            dps.scrollTo(today);
        }
        else {
            let start = now;
            switch (this.state.resolution) {
                case this.timeResolutionTypes.Days:
                    start = Helper.dates.addDays(now, (this.prevCells) * -1);
                    break;
                case this.timeResolutionTypes.Week:
                    start = Helper.dates.addDays(now, (this.prevCells) * -7)
                    start = Helper.dates.getLastMonday(start);
                    break;
                case this.timeResolutionTypes.Month:
                    start = new Date(now.getFullYear(), now.getMonth() - this.prevCells, 1);
                    break;
                case this.timeResolutionTypes.Hours:
                    start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0);
                    break;
            }

            let days = Helper.dates.dateDiffInDays(this.props.start, this.props.end);
            let end = Helper.dates.addDays(start, days);

            // Aktueller Tag befindet sich nicht im Zeitraum. Kann vorkommen wegen prevCells und hoher Zoomstufe -> dann erste Zelle = aktuelles Datum phne preCells
            if (Helper.dates.compareMultiTypeDates(now, start, true) == -1 || Helper.dates.compareMultiTypeDates(end, now, true) == -1) {
                start = now;
                switch (this.state.resolution) {
                    case this.timeResolutionTypes.Days:
                        break;
                    case this.timeResolutionTypes.Week:
                        start = Helper.dates.getLastMonday(start);
                        break;
                    case this.timeResolutionTypes.Month:
                        start = new Date(now.getFullYear(), now.getMonth(), 1);
                        break;
                    case this.timeResolutionTypes.Hours:
                        start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0);
                        break;
                }

                days = Helper.dates.dateDiffInDays(this.props.start, this.props.end);
                end = Helper.dates.addDays(start, days);
            }

            this.props.onTimeSpanChanged(start, end, this.props.timeResolutionType, true);
        }
    }

    private handleTimeRangeZoom = (zoomIn: boolean) => {
        const dps = (window["dps"] as DayPilot.Scheduler);

        if (dps.cellWidthSpec == "Fixed") {
            if (zoomIn) {
                dps.cellWidth = Math.round(dps.cellWidth * 1.25);
            }
            else {
                dps.cellWidth = Math.round(dps.cellWidth * 0.75);
            }
            dps.update();
        }
        else {
            if (zoomIn) {
                this.sendValues(this.props.zoomInStart, this.props.zoomInEnd, this.props.timeResolutionType);
            } else {
                this.sendValues(this.props.zoomOutStart, this.props.zoomOutEnd, this.props.timeResolutionType);
            }
        }
    }

    private getDateString = (date: SD): string => {
        let d: Date;
        if (typeof date === "string") {
            d = kendo.parseDate(date);
        } else {
            d = date;
        }

        return kendo.toString(d, "d");
    }

    private onWindowResize = () => {
        this.refreshDimensionsAndColumnCounts(false);
    }

    private handleCheckBoxChange = (value: boolean) => {
        this.onFilterPartChange("fitToScreen", value, false);
    }

    private handleSwitchToBestFit = () => {
        if (this.state.recommendation && this.state.resolution !== this.state.recommendation.bestFit) {
            this.setState({ resolution: this.state.recommendation.bestFit });
        }
    }

    private handleSwitchToMinFitResolution = () => {
        if (this.state.recommendation && this.state.resolution !== this.state.recommendation.minFit) {
            this.onFilterPartChange("resolution", this.state.recommendation.minFit, false);
        }
    }

    private handleSwitchToMinFitEndDate = () => {
        if (this.state.recommendation && Helper.dates.compareMultiTypeDates(this.state.end, this.state.recommendation.endDate, true) !== 0) {
            this.onFilterPartChange("end", this.state.recommendation.endDate, false);

        }
    }

    private shouldShowBestFitResolution = () => {
        return this.state.fitToScreen && this.state.recommendation && Helper.hasValue(this.state.recommendation.bestFit) && this.state.recommendation.bestFit !== this.state.resolution;
    }

    private shouldShowMinFitZoom = () => {
        return this.state.fitToScreen
            && this.state.recommendation
            && Helper.hasValue(this.state.recommendation.minFit)
            && this.state.recommendation.minFit > this.state.resolution;
    }

    private shouldShowMinFitEndDate = () => {
        return this.state.fitToScreen
            && this.state.recommendation
            && Helper.hasValue(this.state.recommendation.endDate)
            && Helper.dates.compareMultiTypeDates(this.state.end, this.state.recommendation.endDate, true) !== 0;
    }

    private onDialogClosed = () => {
        const reset = !this.dialogButtonClicked;
        this.dialogButtonClicked = false;
        if (reset) {
            this.closeDialog(true);
        }
    }

    private hasDataChanged = () => {
        return (
            Helper.dates.compareMultiTypeDates(this.state.start, this.props.start, true) !== 0
            || Helper.dates.compareMultiTypeDates(this.state.end, this.props.end, true) !== 0
            || this.props.timeResolutionType !== this.state.resolution
        );
    }

    private shouldDisableZoomIn = () => {
        return (this.props.timeResolutionType !== this.timeResolutionTypes.Hours) && (Helper.dates.compareMultiTypeDates(this.props.zoomInStart, this.props.start, true) === 0 && Helper.dates.compareMultiTypeDates(this.props.zoomInEnd, this.props.end, true) === 0);
    }

    private setTimeSpateTemplateValues = (start: Date, end: Date, resolution: number) => {
        this.onFilterPartChange("start", start, true);
        this.onFilterPartChange("end", end, true);
        this.onFilterPartChange("resolution", resolution, true);
        this.setState({ recommendation: null });
    }

    private createButtonsTitles = () => {

        let unit: string;
        let navigatePrev: string = Helper.getValueOrDefault(this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.MoveXBack"], "");
        let navigatePrevOne: string = Helper.getValueOrDefault(this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.MoveXBack"], "");
        let navigateNextOne: string = Helper.getValueOrDefault(this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.MoveXForward"], "");
        let navigateNext: string = Helper.getValueOrDefault(this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.MoveXForward"], "");


        switch (this.props.timeResolutionType) {
            case this.timeResolutionTypes.Days:
            case this.timeResolutionTypes.Hours:
                unit = this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.Days"];
                break;
            case this.timeResolutionTypes.Month:
                unit = this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.Months"];
                break;
            case this.timeResolutionTypes.Week:
                unit = this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.Weeks"];
                break;
        }

        const diffs = this.getDiffs();
        const xPrev = diffs.xPrev;
        const xPrevCustom = diffs.customPrev;
        const xNext = diffs.xNext;
        const xNextCustom = diffs.customNext;


        unit = Helper.getValueOrDefault(unit, Helper.getValueOrDefault(this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.Units"], ""));

        navigatePrev = navigatePrev.replace("{x}", xPrev.toString()).replace("{unit}", unit);
        navigatePrevOne = navigatePrevOne.replace("{x}", this.prevCustomDiff.toString()).replace("{unit}", unit);
        navigateNextOne = navigateNextOne.replace("{x}", this.nextCustomDiff.toString()).replace("{unit}", unit);
        navigateNext = navigateNext.replace("{x}", xNext.toString()).replace("{unit}", unit);


        return ([navigatePrev, navigatePrevOne, navigateNextOne, navigateNext]);
    }

    private getDiffs = () => {
        let xNext: number, xNextCustom: number, xPrev: number, xPrevCustom: number;
        //https://stackoverflow.com/questions/2536379/difference-in-months-between-two-dates-in-javascript
        const monthDiff = (d1: Date, d2: Date) => {
            let months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            return (months <= 0) ? 0 : months;
        }

        xNextCustom = xPrevCustom = 1;
        switch (this.props.timeResolutionType) {
            case this.timeResolutionTypes.Days:
                xPrev = Helper.dates.dateDiffInDays(this.props.prevStart, this.props.start);
                xNext = Helper.dates.dateDiffInDays(this.props.start, this.props.nextStart);
                xPrevCustom = Helper.dates.dateDiffInDays(this.props.prevCustomEnd, this.props.end);
                xNextCustom = Helper.dates.dateDiffInDays(this.props.start, this.props.nextCustomStart);
                break;
            case this.timeResolutionTypes.Hours:
                xPrev = Helper.dates.dateDiffInDays(this.props.prevStart, this.props.start);
                xNext = Helper.dates.dateDiffInDays(this.props.start, this.props.nextStart);
                xPrevCustom = Helper.dates.dateDiffInDays(this.props.prevCustomStart, this.props.start);
                xNextCustom = Helper.dates.dateDiffInDays(this.props.start, this.props.nextCustomStart);
                break;
            case this.timeResolutionTypes.Month:
                xPrev = xNext = monthDiff(Helper.dates.toDate(this.props.prevStart), Helper.dates.toDate(this.props.start)) + 1;
                break;
            case this.timeResolutionTypes.Week:
                xNext = Helper.dates.dateDiffInDays(this.props.prevStart, this.props.start);
                xNext = Math.ceil(xNext / 7);
                xPrev = xNext;
                break;
        }
        return {
            xPrev: xPrev,
            customPrev: xPrevCustom,
            xNext: xNext,
            customNext: xNextCustom
        };
    }


    private renderDialog = () => {
        if (!this.state.showDialog || this.props.disabled) {
            return null;
        }
        const dropDownTimeResolutionProps = this.getResolutionDropDownProps();
        const showBestFitZoomRecommendation = this.shouldShowBestFitResolution();
        let bestFitZoom = null;
        if (showBestFitZoomRecommendation) {
            const idx = Helper.findObjIndex(this.resolutionDataSource, "TimeResolution", this.state.recommendation.bestFit);
            if (idx !== -1)
                bestFitZoom = `${this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.SwitchToBestFit"]}: ${this.resolutionDataSource[idx].Description}`;
        }

        const showMinFitZoomRecommendation = this.shouldShowMinFitZoom();
        const showMinFitEndDate = this.shouldShowMinFitEndDate();
        let minFitZoomLabel: string = null;
        if (showMinFitZoomRecommendation) {
            if (Helper.hasValue(this.state.recommendation.minFit)) {
                const idx = Helper.findObjIndex(this.resolutionDataSource, "TimeResolution", this.state.recommendation.minFit);
                if (idx !== -1)
                    minFitZoomLabel = this.resolutionDataSource[idx].Description;
            }
        }

        const onValueChangeFunc = <U extends keyof TimeSpanManagerState>(model: U) => {
            return (value: TimeSpanManagerState[U]) => {
                this.onFilterPartChange(model, value, false);
                this.setState({ selectedTimeSpan: null });
            }
        }

        const recommendation = showMinFitZoomRecommendation || showMinFitEndDate ?
            <div style={{ paddingTop: "10px" }}>
                <p>{this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.MinFitSelection"]}</p>
                <ul style={this._commandLinkStyle}>
                    {
                        showMinFitZoomRecommendation ?
                            <li>
                                <FAIcon name="arrow-right" style={{ display: "inline-block" }} />
                                {this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.SwitchToMinFit"]}: <a onClick={this.handleSwitchToMinFitResolution}>{minFitZoomLabel}</a>
                            </li>
                            : null
                    }
                    {
                        showMinFitEndDate ?
                            <li>
                                <FAIcon name="arrow-right" style={{ display: "inline-block" }} />
                                {this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.SwitchToMaxDate"]}: <a onClick={this.handleSwitchToMinFitEndDate}>{this.getDateString(this.state.recommendation.endDate)}</a>
                            </li>
                            : null
                    }
                </ul>
            </div>
            : null;
        const data = Helper.loadDataFromStorage(this.lastTimeSpanStorageId);
        return (
            <Dialog ref={this.setDialogRef} title={this.props.translations["Einsatz.Einstellungen.ZeitraumSetzen"]} actions={this.dialogActions} open={true} afterClose={this.onDialogClosed}>
                <TimeSpanManager
                    end={new Date(this.state.end)}
                    start={new Date(this.state.start)}
                    onFilterChange={this.setTimeSpateTemplateValues}
                    onEndChange={onValueChangeFunc('end')}
                    onStartChange={onValueChangeFunc('start')}
                    last={Helper.hasValue(data) ? { start: data.start, end: data.end, timeResolutionType: data.resolution } : null}
                />
                <div style={{ display: "grid", gridTemplateRows: "40px auto 40px auto", gridTemplateColumns: "60px 450px", paddingTop: "16px" }} >
                    <div style={{ gridColumn: "1/2", gridRow: "1/2", display: "flex", alignItems: "center" }} >Zoom</div>
                    <div style={{ gridColumn: "2/3", gridRow: "1/2", display: "flex", alignItems: "center" }} >
                        <DropDownList {...dropDownTimeResolutionProps} />
                    </div>
                    <div style={{ gridColumn: "1/3", gridRow: "2/3", display: showBestFitZoomRecommendation ? "flex" : "none", justifyContent: "flex-end" }} >
                        <a onClick={this.handleSwitchToBestFit} style={{ color: "black", fontSize: "12px", marginTop: "5px" }}>{bestFitZoom}</a>
                    </div>
                    <div style={{ gridColumn: "1/3", gridRow: "3/4", display: "flex", alignItems: "center" }} >
                        <SimpleCheckBox onChange={this.handleCheckBoxChange} value={this.state.fitToScreen} label={this.props.translations["WebSMS.ResourcePlanningScheduler.TimeSpanFilter.FitToScreen"]} />
                    </div>
                    <div style={{ gridColumn: "1/3", gridRow: "4/5" }} >
                        {recommendation}
                    </div>
                </div>

            </Dialog>
        );
    }



    async componentDidMount() {
        const result = await HTTPService.get<JsonResultClass>("ResourcePlanningScheduler/GetTimeSpanManagerData");
        //this._pbUnits = {
        //    unitDays: result.AdditionalData.unitDays,
        //    unitWeeks: result.AdditionalData.unitMonths,
        //    unitMonths: result.AdditionalData.unitMonths
        //};
        this.prevCells = result.AdditionalData.prevCells;
        this.setState({})
        window.addEventListener("resize", this.onWindowResize);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }

    componentWillUnmount() {
        $(document).off("keydown", this.onKeyDown);
        window.removeEventListener("resize", this.onWindowResize);
    }

    componentDidUpdate() {
        //const diff = this.getDiffs();
        //let update = false;
        //if (this._prevCustomDiff != diff.customPrev) {
        //    this._prevCustomDiff = diff.customPrev;
        //    update = true;
        //}
        //if (this._nextCustomDiff != diff.customNext) {
        //    this._nextCustomDiff = diff.customNext;
        //    update = true;
        //}
        //if (update) {
        //    this.setState({})
        //}

    }

    render() {
        const buttonTitles = this.createButtonsTitles();
        return (
            <>
                <div style={this._timeSpanStyle} title={this.props.translations["Einsatz.Einstellungen.ZeitraumSetzen"]} onClick={() => this.openDialog()}>
                    {this.getDateString(this.props.start)}
                    {<FAIcon name="arrows-alt-h" sameWidth={true} style={{ display: "inline-block", margin: "0px 5px" }} />}
                    {this.getDateString(this.props.end)}
                </div>
                <Button title={this.props.translations["Standard.Heute"]} handleClick={this.navigateToday} iconName={"calendar-day"} readOnly={this.props.disabled} buttonStyle={{ margin: "0 10px 10px 0", borderRadius: "var(--rounded-right)", backgroundColor: "#e4e7eb", width: "30px" }} />
                <ToggleButtonGroup style={this._toggleGroupStyle}>
                    <Button iconName="search-minus" handleClick={() => this.handleTimeRangeZoom(false)} title={this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.ZoomOut"]} readOnly={this.props.disabled} buttonStyle={{ borderRadius: "var(--rounded-left)" }} />
                    <Button iconName="search-plus" handleClick={() => this.handleTimeRangeZoom(true)} title={this.props.translations["WebSMS.ResourcePlanningScheduler.Navigation.ZoomIn"]} readOnly={this.props.disabled || this.shouldDisableZoomIn()} buttonStyle={{ borderRadius: "var(--rounded-right)" }} />
                </ToggleButtonGroup>
                <ToggleButtonGroup style={this._toggleGroupStyle}>
                    <Button handleClick={this.navigatePrev} iconName={"arrow-left"} readOnly={this.props.disabled} title={buttonTitles[0]} buttonStyle={{ borderRadius: "var(--rounded-left)" }} />
                    <Button handleClick={this.navigatePrevCustom} layerIcons={[{ name: "arrow-left" }, { name: this.prevCustomDiff.toString(), isText: true, style: { fontSize: "0.7em", position: "absolute", top: "25%" } }]} readOnly={this.props.disabled} title={buttonTitles[1]} buttonStyle={{ width: "38px" }} iconStyle={{ display: "flex" }} />
                    <Button handleClick={this.navigateNextCustom} layerIcons={[{ name: "arrow-right" }, { name: this.nextCustomDiff.toString(), isText: true, style: { fontSize: "0.7em", position: "absolute", top: "25%" } }]} readOnly={this.props.disabled} title={buttonTitles[2]} buttonStyle={{ width: "38px" }} iconStyle={{ display: "flex" }} />
                    <Button handleClick={this.navigateNext} iconName={"arrow-right"} readOnly={this.props.disabled} title={buttonTitles[3]} buttonStyle={{ borderRadius: "var(--rounded-right)" }} />
                </ToggleButtonGroup>
                {
                    this.renderDialog()
                }
            </>
        );
    }
}

interface TimeSpanManagerState {
    start: SD;
    end: SD;
    resolution: number;
    fitToScreen: boolean;
    showDialog: boolean;
    recommendation: Recommendation;
    selectedTimeSpan: string;
}

type SD = string | Date;

interface Recommendation {
    units: number;
    minFit: number;
    bestFit: number;
    endDate: string;
}

interface ZoomDataItem {
    TimeResolution: number;
    Description: string
}

enum RerenderCondition {
    Never, Always, BestFit, MinFit
}

export interface ResourcePlanningSchedulerTimeSpanManagerProps {
    start: string | Date;
    end: string | Date;
    nextStart: string | Date;
    nextEnd: string | Date;
    prevStart: string | Date;
    prevEnd: string | Date;
    nextCustomStart: string | Date;
    nextCustomEnd: string | Date;
    prevCustomStart: string | Date;
    prevCustomEnd: string | Date;
    todayStart: string | Date;
    todayEnd: string | Date;
    zoomInStart: string | Date;
    zoomInEnd: string | Date;
    zoomOutStart: string | Date;
    zoomOutEnd: string | Date;
    timeResolutionType: number;
    onTimeSpanChanged: (start: string | Date, end: string | Date, resolution: number, doNotChangeCellWidth?: boolean, setSchedulertoStartDate?: boolean) => void;
    translations: StringKeyDictionary<string>;
    fixedCellWidth: number;
    fitToScreen: boolean;
    disabled: boolean;
}

interface ColumnFitSizes {
    minCount: number;
    bestFitCount: number;
}

interface TimeSpanTemplate {
    resolution: number;
    startDate: Date;
    endDate: Date;
    text: string;
    description: string;
    id: string;
}